import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import StatusFilter from './StatusFilter';
import {MatchTotalCountPerStatus} from '../../../../../../types/shared-recruiting-types';

interface HeaderProps {
  selected: string;
  handleToggle: (value: string) => void;
  totalCountPerStatus: MatchTotalCountPerStatus;
}

export default function Header({selected, handleToggle, totalCountPerStatus}: HeaderProps) {
  const {t} = useTranslation();

  return (
    <Grid
      container
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        marginBottom: '36px',
        width: '100%',
      }}
    >
      <Grid item>
        <Typography variant='h1' display={'flex'} gap={1}>
          {t('companyInbox.inboxPageHeader.title')}
        </Typography>
      </Grid>

      <Grid
        item
        sx={{
          width: {xs: '100%', md: 'auto'},
        }}
      >
        <StatusFilter handleSelected={handleToggle} selected={selected} totalCountPerStatus={totalCountPerStatus} />
      </Grid>
    </Grid>
  );
}
